import { render, staticRenderFns } from "./RatingScreen.vue?vue&type=template&id=f0d568ac&scoped=true&"
import script from "./RatingScreen.vue?vue&type=script&lang=js&"
export * from "./RatingScreen.vue?vue&type=script&lang=js&"
import style0 from "./RatingScreen.vue?vue&type=style&index=0&id=f0d568ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d568ac",
  null
  
)

export default component.exports